import { render } from "./web_top.vue?vue&type=template&id=14a125cd&scoped=true&ts=true"
import script from "./web_top.vue?vue&type=script&lang=ts"
export * from "./web_top.vue?vue&type=script&lang=ts"

import "./web_top.vue?vue&type=style&index=0&id=14a125cd&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a125cd"]])

export default __exports__